export default (event) => {
  switch (event.color) {
    case '#FFD174':
      return 'gold';
    case '#C30000':
    default:
      return 'red';
  }
};
